import React, { Component } from 'react'
import { connect } from 'react-redux'
import { compose } from 'redux'
import { withRouter } from "react-router-dom"
//import { NavLink} from "react-router-dom";
import axios from 'axios'
import { connectNode } from '../../../utils/global'
import { escapeHtml } from '../../../utils/textFunctions'
//import '../../../styles/assets/css/pages/form5.css'
import { loadLocationWithMessage } from '../../../actions/location'
import { scid_ynne, scid_v1_q_c, scid_v1_q_c11, scid_v1_q_c12 }
from '../variables/assessments/scid_v1.js'

import WarningIcon from '@material-ui/icons/Warning'
import TextField from '@material-ui/core/TextField'
import Button from '@material-ui/core/Button'
import ArrowRightIcon from '@material-ui/icons/ArrowRight'

import StepperSCID_v1 from './stepper_SCID_v1'

class Scid3_v1 extends Component {
  constructor() {
      super()
      //var [fields, setFields] = useState([{ value: null }])
      this.state = {
          status: false,
          completed_status: false,
          edit_status: false,
          message: '',
          appt_id: 0,
          start_time: Math.floor(new Date().getTime()/1000),
          next_step: 'scid4_v1',
          c1: 0,
          c2: 0,
          c3: 0,
          c4: 0,
          c5: 0,
          c6: 0,
          c7: 0,
          c8: 0,
          c9: 0,
          c10: 0,
          c111: 0,
          c112: 0,
          c113: 0,
          c12: 0,
      }
  }

  componentDidMount() {
    window.scrollTo(0, 0)
    this.getAssmProcess()
    //console.log(this.state.start_datetime)
  }

  getAssmProcess = () => {
    if(this.props.match.params.task == 'edit') {
      this.getData('edit')
    } else {
      // Initial MINI form to database //
      axios({
        method: 'post',
        url: connectNode + 'admin/assessment/chk_scid_v1_status',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json;charset=UTF-8'
        },
        data: {
          uid: this.props.authReducer.uid,
          pid: this.props.match.params.pid,
          timepoint: this.props.match.params.timepoint,
        }
      })
      .then((result) => {
        //console.log(result['data'])
        if(result['data'] === 0) {
          this.setState({
            message: 'Something went wrong.',
          })
        } else {
          //console.log('step: '+result['data'].mini_step)
          if(result['data'].scid_step === 'complete') {
            this.props.history.push('/admin/assessments/scid_v1_result/'+this.props.match.params.pid+'/'+this.props.match.params.timepoint)
          } else if(result['data'].scid_step !== 'scid3_v1') {
            this.getData('new')
          } else {
            this.setState({
              appt_id: result['data'].id,
            })
          }
        }
      })
    }
  }

  getData = (edit_status) => {
    var get_edit_status = false
    if(edit_status == 'edit') {
      get_edit_status = true
    }
    axios({
      method: 'post',
      url: connectNode + 'admin/assessment/get_scid_v1_data',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json;charset=UTF-8'
      },
      data: {
        pid: this.props.match.params.pid,
      }
    })
    .then((result) => {
      if(result['data'].end_2_timestamp > 0) {
        this.setState({
          completed_status: true,
          edit_status: get_edit_status,
          c1: result['data'].c1,
          c2: result['data'].c2,
          c3: result['data'].c3,
          c4: result['data'].c4,
          c5: result['data'].c5,
          c6: result['data'].c6,
          c7: result['data'].c7,
          c8: result['data'].c8,
          c9: result['data'].c9,
          c10: result['data'].c10,
          c111: result['data'].c111,
          c112: result['data'].c112,
          c113: result['data'].c113,
          c12: result['data'].c12,
        })
      }
    })
  }

  handleChange = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    })
  }

  handleChange7 = (e) => {
    var val = 0
    if (e.target.checked) {
      val = 1
    }
    this.setState({
      [e.target.name]: val,
    })
  }

  handleNext = (page) => {
    window.location.href = "/admin/assessments/"+page+"/"+this.props.match.params.pid+"/-1"
  }

  handleSubmit = (e) => {
    e.preventDefault()
    var pid = this.props.match.params.pid
    var timepoint = this.props.match.params.timepoint

    axios({
      method: 'post',
      url: connectNode + 'admin/assessment/update_scid3_v1',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json;charset=UTF-8'
      },
      data: {
        uid: this.props.authReducer.uid,
        user: this.state,
        pid: pid,
        timepoint: timepoint,
      }
    })
    .then((result) => {
      if(result['data'] === this.state.next_step) {
        this.props.onLoadLocation('/admin/assessments/'+this.state.next_step+'/'+pid+'/'+timepoint)
        this.props.history.push('/admin/assessments/'+this.state.next_step+'/'+pid+'/'+timepoint)
      }
    })
  }

  handleEdit = (e) => {
    e.preventDefault()
    var pid = this.props.match.params.pid
    var timepoint = this.props.match.params.timepoint
    axios({
      method: 'post',
      url: connectNode + 'admin/assessment/edit_scid3_v1',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json;charset=UTF-8'
      },
      data: {
        uid: this.props.authReducer.uid,
        user: this.state,
        pid: pid,
        task: 'edit',
      }
    })
    .then((result) => {
      if(result['data'] == pid) {
        this.props.onLoadLocation('/admin/assessments/scid_v1_result/'+pid+'/-1', 'Edit successfully!')
        this.props.history.push('/admin/assessments/scid_v1_result/'+pid+'/-1')
      }
    })
  }

  render() {
    return (
      <div className="assm_mini box_border4">
        { //this.state.appt_id > 0 &&
        <div className="row">
          <div className="small-12 columns headerPage1">
            QuickSCID5: Intake Appointment
          </div>
          <StepperSCID_v1 activeStep={2} type={this.props.match.params.type} timepoint={this.props.match.params.timepoint} />
        </div>}
        { this.state.message !== '' &&
        <div className="row warning_msg6">
          <div className="small-12 columns ">
            <div className="float_left1"><WarningIcon /></div>
            <div className="txt_warning_msg1">{ this.state.message }</div>
          </div>
        </div>}
        { //(this.state.appt_id > 0 || this.props.match.params.task == 'edit') &&
          <form onSubmit={this.handleSubmit}>
          <div className="row">
            <div className="small-12 columns box1">
              <div className="row show-for-medium bold">
                <div className="medium-9 columns">&nbsp;</div>
                {scid_ynne.map(each =>
                  each.value > 0 &&
                  <div className="medium-1 columns headerResize1" key={'sch'+each.label}>
                    {each.label}
                  </div>
                )}
                <div className="small-12 columns">
                  <div className="sep_line1">&nbsp;</div>
                </div>
              </div>

              {scid_v1_q_c.map(eachQ =>
              <>
              <div className="row" >
                <div className="small-12 medium-9 columns">
                  C{eachQ.value}. {eachQ.label}
                </div>
                {scid_ynne.map(each =>
                  each.value > 0 &&
                  <div className="small-12 medium-1 columns align_center" key={'sc'+each.label}>
                    <input type="radio" name={"c"+eachQ.value} value={each.value}
                    checked={this.state['c'+eachQ.value] == each.value && 'checked'}
                    disabled={(this.state.completed_status && !this.state.edit_status) && 'disabled'}
                    onChange={(e) => this.handleChange(e)}/>
                    <span className="show-for-small-only">{each.label}</span>
                  </div>
                )}
              </div>
              <div className="row">
                <div className="small-12 columns"><div className="sep_line2">&nbsp;</div></div>
              </div>
              </>)}

              <div className="row" >
                <div className="small-12 columns bottom_space2">
                  C11. Check the type of ADHD:
                </div>
                {scid_v1_q_c11.map(each =>
                <div className="small-12 columns bottom_space2" key={'ac1'+each.label}>
                  <input type="checkbox" value="1" name={'c11'+each.value}
                    checked={this.state['c11'+each.value]} className="each_checkbox1"
                    onChange={(e) => this.handleChange7(e)} />
                  <span>{each.label}</span>
                </div>)}
              </div>
              <div className="row">
                <div className="small-12 columns"><div className="sep_line2">&nbsp;</div></div>
              </div>

              {scid_v1_q_c12.map(eachQ =>
              <>
              <div className="row" >
                <div className="small-12 medium-9 columns">
                  C{eachQ.value}. {eachQ.label}
                </div>
                {scid_ynne.map(each =>
                  each.value > 0 &&
                  <div className="small-12 medium-1 columns align_center" key={'cc'+each.label}>
                    <input type="radio" name={"c"+eachQ.value} value={each.value}
                    checked={this.state['c'+eachQ.value] == each.value && 'checked'}
                    disabled={(this.state.completed_status && !this.state.edit_status) && 'disabled'}
                    onChange={(e) => this.handleChange(e)}/>
                    <span className="show-for-small-only">{each.label}</span>
                  </div>
                )}
              </div>
              <div className="row">
                <div className="small-12 columns"><div className="sep_line2">&nbsp;</div></div>
              </div>
              </>)}

            </div>

          <div className="small-12 columns align_right">
            {!this.state.completed_status &&
            <Button variant="contained" color="primary" disableElevation
               onClick={this.handleSubmit} type="submit" className="submit_1">
                Submit
            </Button>}
            {this.state.completed_status && !this.state.edit_status &&
            <Button variant="contained" color="primary" disableElevation
               onClick={(e) => this.handleNext('scid4_v1')} className="submit_1">
                Next
            </Button>}
            {this.state.edit_status &&
            <Button variant="contained" color="primary" disableElevation
               onClick={this.handleEdit} className="submit_1">
                Submit
            </Button>}
          </div>
        </div>
        </form>
        }

    </div>
    );
  }
}

const mapStateToProps = (state) => {
  return state
}

const mapDispatchToProps = (dispatch) => ({
  onLoadPages(response) {
    dispatch({
      type: 'LOAD_USER_AUTH',
      payload: response,
    })
  },
  onLoadLocation(route, msg) {
    dispatch(loadLocationWithMessage(route, msg))
  },
})

export default compose(withRouter, connect(mapStateToProps, mapDispatchToProps))(Scid3_v1)
